import React from 'react';
import Icon from '../../../components/AppIcon';

const PayrollDashboardCard = ({ title, value, subtitle, icon, color }) => {
  const colorClasses = {
    blue: 'from-blue-500 to-blue-600 text-blue-600 bg-blue-50',
    purple: 'from-purple-500 to-purple-600 text-purple-600 bg-purple-50',
    green: 'from-green-500 to-green-600 text-green-600 bg-green-50',
    emerald: 'from-emerald-500 to-emerald-600 text-emerald-600 bg-emerald-50'
  };

  const [gradientClass, textClass, bgClass] = colorClasses?.[color]?.split(' ') || colorClasses?.blue?.split(' ');

  return (
    <div className="bg-white rounded-xl shadow-md border border-gray-200 p-5 hover:shadow-lg transition-shadow">
      <div className="flex items-start justify-between mb-3">
        <div className={`p-2.5 bg-gradient-to-br ${gradientClass} rounded-lg shadow-sm`}>
          <Icon name={icon} className="h-6 w-6 text-white" />
        </div>
      </div>
      <div className="space-y-1">
        <p className="text-sm font-medium text-gray-600">{title}</p>
        <p className={`text-3xl font-bold ${textClass}`}>{value}</p>
        <p className="text-xs text-gray-500">{subtitle}</p>
      </div>
    </div>
  );
};

export default PayrollDashboardCard;